import {NgModule} from "@angular/core";
import {LastMedlemmerAvhengighet} from "./komponenter/ny-kommentar-traad/ny-kommentar-traad";
import {KommentarTraadKomponentAvhengigheter} from "web-ng2/moduler/kommentar/komponenter/kommentar-traad/kommentar-traad";
import {KommentarTraaderKomponentAvhengigheter} from "web-ng2/moduler/kommentar/komponenter/kommentar-traader/kommentar-traader";
import {NyttKommentarSvarKomponentAvhengigheter} from "web-ng2/moduler/kommentar/komponenter/nytt-kommentar-svar/nytt-kommentar-svar";
import {KommentarerTellerKomponentAvhengigheter} from "web-ng2/moduler/kommentar/komponenter/kommentarer-teller/kommentarer-teller";
import {KommentarerKomponentAvhengigheter} from "web-ng2/moduler/kommentar/komponenter/kommentarer/kommentarer";

@NgModule({
    providers: [
        KommentarTraaderKomponentAvhengigheter,
        KommentarTraadKomponentAvhengigheter,
        NyttKommentarSvarKomponentAvhengigheter,
        LastMedlemmerAvhengighet,
        KommentarerTellerKomponentAvhengigheter,
        KommentarerKomponentAvhengigheter
    ]
})
export class KommentarModul{

}
